// 中文语言包（key 结构须与 en-US.js 严格一致）
// 命名空间按模块组织；通用文案归入 common，页面标题归入 routes（供 meta.titleKey 使用）
export default {
  common: {
    siteName: '景天下',
    companyName: '景天下科技',
    home: '首页',
    viewDetail: '查看详情',
    more: '了解更多',
    uncategorized: '未分类',
    dateFormat: 'YYYY 年 MM 月 DD 日',
    back: '返回',
    loading: '加载中...',
    underConstruction: '该页面正在建设中，敬请期待'
  },
  routes: {
    home: '首页',
    about: '关于我们',
    history: '发展历程',
    team: '管理团队',
    organization: '组织架构',
    honors: '企业荣誉',
    news: '企业动态',
    new: '新闻详情',
    media: '媒体报道',
    newsVideo: '视频中心',
    touch: '联系我们',
    boxs: '业务领域',
    box: '业务详情',
    services: '主营业务',
    serviceDetail: '主营业务详情',
    projects: '典型项目',
    recruits: '人才招聘',
    campus: '校园招聘',
    social: '社会招聘',
    intern: '实习生招聘',
    product: '企业文化',
    socialResp: '社会责任',
    socialRespDetail: '社会责任详情',
    innovation: '创新发展',
    innovationDetail: '创新发展详情',
    docs: '文档中心',
    doc: '文档详情',
    privacy: '隐私政策',
    terms: '服务条款',
    sitemap: '网站地图',
    search: '搜索',
    notFound: '页面未找到',
    jobCategoryDetail: '职位类别详情'
  },
  nav: {
    search: '搜索',
    admin: '管理入口',
    about: '关于我们',
    profile: '公司简介',
    history: '发展历程',
    team: '管理团队',
    organization: '组织架构',
    honors: '企业荣誉',
    news: '企业动态',
    newsList: '新闻资讯',
    media: '媒体报道',
    video: '视频中心',
    business: '业务领域',
    businessOverview: '业务概览',
    services: '主营业务',
    projects: '典型项目',
    culture: '企业文化',
    socialResp: '社会责任',
    innovation: '创新发展',
    recruits: '人才招聘',
    touch: '联系我们',
    switchToEn: 'EN',
    switchToZh: '中'
  },
  footer: {
    aboutJtx: '关于景天下',
    profile: '公司简介',
    history: '发展历程',
    team: '管理团队',
    organization: '组织架构',
    honors: '企业荣誉',
    business: '主营业务',
    businessOverview: '业务概览',
    software: '软件开发',
    integration: '系统集成',
    consulting: '技术咨询',
    projects: '典型项目',
    news: '企业动态',
    newsList: '新闻资讯',
    media: '媒体报道',
    video: '视频中心',
    socialResp: '社会责任',
    recruits: '人才招聘',
    jobs: '招聘岗位',
    campus: '校园招聘',
    social: '社会招聘',
    intern: '实习生招聘',
    touch: '联系我们',
    address: '北京市昌平区王府街21号宝隆艺园50号楼203室',
    phone: '010-89757238',
    fax: '传真：010-89757238',
    email: "jtx{'@'}jingtianxia.com",
    workTime: '工作时间：周一至周五 9:00-18:00',
    wechat: '景天下科技',
    companySlogan: '专注智慧空间与智慧园林的创新升级的高科技企业',
    copyright: '© {year} 景天下生态环境科技有限公司 版权所有',
    icpPrefix: '京ICP备',
    icpMid: "号 {'|'} 京公网安备 ",
    icpSuffix: '号',
    privacy: '隐私政策',
    terms: '服务条款',
    sitemap: '网站地图'
  },
  home: {
    newsSectionTitle: '正在发生',
    readFull: '阅读全文',
    exploreMore: '探索更多',
    videoTitle: '科技赋予想象 时代重新定义',
    videoDesc: '景天下专注于园林智慧养护领域，利用物联网、云计算、AI模型等前沿科技与传统园林养护相结合，为客户提供全方位的智慧养护解决方案。近年来致力于创新的、生态的、复合化的园林景观产品研发和相关技术服务输出。',
    videoNotSupported: '您的浏览器不支持视频播放。',
    joinTitle: '加入景天下',
    joinSubtitle: '遇见新未来，发现新自己',
    joinDesc: '我们秉持能力导向、全面发展的人才理念，为有能力的员工提供广阔的发展舞台',
    joinUs: '加入我们',
    clientsTitle: '服务客户',
    carousel1Title: '分析土地之力，创造土地之美',
    carousel1Subtitle: '景天下，以美利利天下',
    carousel2Title: '以创新技术赋能企业数字化转型',
    carousel2Subtitle: '技术引领发展',
    carousel2Button: '我们的业务',
    carousel3Title: '构建可持续发展的数字化未来',
    carousel3Subtitle: '共创美好未来',
    area1Title: '智慧空间',
    area1Desc: '通过高科技产品赋予物理空间主动性，使其能感知人、判别活动并精准服务，实现人与空间的深度互动，带来前所未有的主动关怀体验。',
    area2Title: '智慧园林',
    area2Desc: '以“精准养护”为核心，实现从传统到创新、从相隔到相通、从经验到量化的不断升级',
    area3Title: '技术咨询',
    area3Desc: '提供专业技术咨询，帮助企业规划IT战略',
    area4Title: '解决方案',
    area4Desc: '针对行业痛点提供一站式整体解决方案'
  },
  news: {
    subtitle: '了解景天下科技的最新资讯和行业动态',
    allCategories: '全部分类',
    empty: '暂无相关新闻',
    articleBody: '正文',
    readTime: '阅读约 {n} 分钟',
    metaBrand: '景天下科技 · 企业动态',
    watermark: '绿',
    notExist: '新闻不存在或已下线',
    backToNews: '返回新闻列表',
    tocTitle: '本篇目录',
    backToList: '返回动态列表',
    keepReading: '继续阅读',
    keepReadingEn: 'KEEP READING',
    // 媒体报道页
    mediaDesc: '我们的企业发展与创新受到各大媒体的广泛关注与报道，以下是各大媒体对我们的相关报道。',
    mediaAll: '全部媒体',
    mediaFinance: '财经媒体',
    mediaTech: '科技媒体',
    mediaIndustry: '行业媒体',
    mediaOther: '其他媒体',
    mediaYearFilter: '年份筛选',
    mediaAllYears: '全部年份',
    mediaEmpty: '暂无相关媒体报道',
    mediaCoopTitle: '媒体合作',
    mediaCoopDesc: '我们欢迎各类媒体的采访和报道。如有采访需求或媒体合作，请联系我们的公关部门。',
    mediaContactPersonLabel: '联系人：',
    mediaContactPerson: '李媒体关系总监',
    mediaContactPhoneLabel: '电话：',
    mediaContactEmailLabel: '邮箱：',
    media1Title: '科技创新引领未来：XX企业数字化转型解决方案获广泛认可',
    media1Source: '中国经济网',
    media1Summary: '近日，XX企业推出的数字化转型解决方案在行业内获得广泛认可，多家大型企业已采用该方案实现业务升级...',
    media2Title: '专访XX企业CEO：如何在数字经济时代保持创新力',
    media2Source: '人民日报',
    media2Summary: '在这个快速变化的数字经济时代，企业如何保持创新活力？本报记者近日专访了XX企业CEO张志远...',
    media3Title: 'XX企业入选“2023年度最具创新力企业”榜单',
    media3Source: '财经周刊',
    media3Summary: '近日，知名财经媒体发布“2023年度最具创新力企业”榜单，XX企业凭借在企业服务领域的突出表现入选...',
    media4Title: '破解企业数字化难题：XX企业推出新一代SaaS平台',
    media4Source: '科技日报',
    media4Summary: '如何有效解决中小企业在数字化转型过程中面临的各种难题？XX企业日前推出的新一代SaaS平台或许能够提供答案...',
    media5Title: '技术驱动业务增长：XX企业AI应用案例分析',
    media5Source: '互联网周刊',
    media5Summary: 'AI技术如何真正为企业创造价值？本文通过分析XX企业在多个行业的AI应用案例，探讨AI技术与业务的深度融合...',
    media6Title: 'XX企业发布年度行业白皮书，预测2023年十大技术趋势',
    media6Source: '信息时报',
    media6Summary: '日前，XX企业发布“2023企业数字化发展白皮书”，对未来一年企业数字化发展的十大技术趋势进行了深度解析...',
    media7Title: '聚焦产业互联网：XX企业助力传统制造业转型升级',
    media7Source: '制造业评论',
    media7Summary: '在产业互联网浪潮下，传统制造业如何实现数字化转型？XX企业通过一系列解决方案助力多家制造企业成功转型...',
    media8Title: 'XX企业荣获“企业服务领域年度标杆企业”称号',
    media8Source: '商业观察家',
    media8Summary: '在日前举行的“2022中国企业服务峰会”上，XX企业凭借出色的产品和服务获得“年度标杆企业”荣誉称号...',
    media9Title: 'XX企业完成B轮融资，投资方青睐其技术创新能力',
    media9Source: '投资时报',
    media9Summary: '近日，XX企业宣布完成B轮融资，融资金额达5亿元。多家知名投资机构参与此轮投资，看好其在技术创新方面的潜力...',
    media10Title: '数据安全与隐私保护：XX企业解决方案获行业认可',
    media10Source: '网络安全报',
    media10Summary: '在数据安全和隐私保护日益重要的今天，XX企业推出的安全解决方案因其先进性和有效性获得行业广泛认可...',
    media11Title: 'XX企业亮相2022国际软件展，创新产品引关注',
    media11Source: '软件产业报',
    media11Summary: '在刚刚结束的2022国际软件展上，XX企业展示的一系列创新产品引发了与会者的广泛关注和好评...',
    media12Title: '2021年度科技创新企业50强：XX企业位列前十',
    media12Source: '商业周刊',
    media12Summary: '近日发布的“2021年度科技创新企业50强”榜单中，XX企业凭借持续的技术创新和市场表现位列前十...',
    // 视频中心页
    videoDesc: '通过精彩视频内容，了解我们的企业文化、产品演示、技术分享和行业洞察。',
    videoAll: '全部视频',
    videoCorporate: '企业宣传',
    videoProduct: '产品演示',
    videoTech: '技术分享',
    videoEvent: '活动回顾',
    videoViews: '{n}次观看',
    videoLoadMore: '加载更多',
    videoEmpty: '暂无相关视频',
    videoCover: '视频封面',
    videoDateLabel: '发布时间：',
    videoIntroTitle: '视频介绍',
    videoRelatedTitle: '相关推荐'
  },
  notFound: {
    title: '页面未找到',
    desc: '抱歉，您访问的页面不存在或已被移除',
    backHome: '返回首页',
    searchContent: '搜索内容'
  },
  contactForm: {
    title: '联系我们',
    desc: '如果您有任何问题或需求，欢迎通过以下表单联系我们，我们将尽快回复您。',
    nameLabel: '您的姓名',
    namePlaceholder: '请输入您的姓名',
    emailLabel: '您的邮箱',
    emailPlaceholder: '请输入您的邮箱',
    phoneLabel: '您的电话',
    phonePlaceholder: '请输入您的电话号码',
    subjectLabel: '主题',
    subjectPlaceholder: '请选择咨询主题',
    messageLabel: '您的留言',
    messagePlaceholder: '请详细描述您的需求或问题，我们会尽快回复您',
    submit: '提交留言',
    confirm: '确定',
    successTitle: '提交成功',
    successMessage: '感谢您的留言，我们将尽快与您联系！',
    failTitle: '提交失败',
    failMessage: '很抱歉，提交失败，请稍后再试或直接联系我们。',
    // 验证规则
    nameRequired: '请输入您的姓名',
    nameLength: '姓名长度应在 2 到 20 个字符之间',
    emailRequired: '请输入您的邮箱',
    emailFormat: '请输入正确的邮箱格式',
    phoneRequired: '请输入您的电话号码',
    phoneFormat: '请输入正确的手机号码格式',
    subjectRequired: '请选择咨询主题',
    messageRequired: '请输入您的留言内容',
    messageLength: '留言内容应在 10 到 500 个字符之间',
    // 咨询主题选项（value 保持中文以兼容后端约定）
    subjectProduct: '产品咨询',
    subjectTech: '技术支持',
    subjectCoop: '合作洽谈',
    subjectComplaint: '投诉建议',
    subjectOther: '其他'
  },
  about: {
    overviewTitle: '公司概况',
    profilePara1: '景天下是集园林规划设计、施工养护为一体的景观生态企业，旗下有景天下生态环境科技有限公司、景天下（北京）科技有限公司、景观规划设计院和苗圃基地。',
    profilePara2: '自2019年起，公司对传统园林进行升级，确定“智慧景观”战略。景天下以“精准养护”为核心，将人工养护升级为智慧管理自养护，运用互联网、物联网、大数据、云计算等新技术，整合资源，实现服务、管理、养护的数字可视化与智能化控制，打造人与环境互动的智慧景观。',
    profilePara3: '公司拥有风景园林专项设计甲级、城市园林绿化施工一级等资质，具备专业设计、科技研发团队，雄厚技术力量，精湛施工队伍，先进设备，以及近4500亩苗木花卉基地。',
    environmentTitle: '公司环境',
    videoTitle: '公司介绍',
    videoDesc: '了解景天下科技的业务',
    videoNotSupported: '您的浏览器不支持视频播放。',
    teamTitle: '核心团队',
    teamDesc: '景天下科技拥有一支充满激情和专业素养的精英团队',
    member1Name: '李艳',
    member1Position: '董事长',
    member1Desc: '专注于智慧景观与园林生态领域，致力于打造园林景观行业产业互联网平台，带领团队在园林景观设计、施工、研发、创新等方面深入研究，取得20余项著作及软件成果，其智慧景观系统广泛应用，多次获政府和企业奖项。',
    member2Name: '刘建军',
    member2Position: '景天下生态总经理',
    member2Desc: '园林生态领域深耕10年，积累了丰富的行业洞察和企业管理经验，带领团队突破传统园林设计施工与技术，成功将传统人工养护升级为智慧管理自养护。',
    member3Name: '周静',
    member3Position: '景天下科技总经理',
    member3Desc: '专注于园林智慧养护领域，致力于将物联网、云计算、AI模型等前沿科技与传统园林养护相结合，为客户提供全方位的智慧养护解决方案。',
    member4Name: '李陵',
    member4Position: '技术总监',
    member4Desc: '大数据专家，深耕大数据超10+年，专注于云计算、物联网、大数据、AI等领域的技术研发和应用。',
    // 发展历程页
    historyTitle: '我们的发展历程',
    historyDesc: '从创立至今，我们不断创新发展，为客户提供更优质的服务和产品，见证了企业的成长与蜕变。',
    historyItem1Title: '公司成立',
    historyItem1Date: '2011年-2013年',
    historyItem1Desc: '景天下（北京）园林市政工程有限公司正式成立<br/>建立景天下苗圃基地<br/>成为远洋供应商集采单位<br/>成为中铁置业集采单位',
    historyItem2Title: '成立智慧景观研发部',
    historyItem2Date: '2014年-2016年',
    historyItem2Desc: '成为金地集团供应商集采单位<br/>成为北京城建地产供应商集采单位<br/>成为太原市政府供应商集采单位<br/>成立景天下（北京）生态文化有限公司<br/>被评定为国家高新技术企业',
    historyItem3Title: '开启智慧景观研发历程',
    historyItem3Date: '2017年-2018年',
    historyItem3Desc: '公司更名 “景天下生态环境科技有限公司”<br/>成为中交地产供应商集采单位，并在四平参与中交项目的智慧景观设计<br/>空港中央公园智慧景观设计与建设<br/>成为保利控股集团战采单位<br/>成为北京建工集采单位<br/>收购华合（北京）国际工程设计有限公司<br/>成为青岛保利区域集采单位<br/>成为太原保利区域集采单位',
    historyItem4Title: '确定景天下 “智慧景观” 的发展战略',
    historyItem4Date: '2019年-2020年',
    historyItem4Desc: '自主研发装配式智慧景观<br/>成为金地地产战采单位<br/>成为美的置业供应商集采单位<br/>成为中国金茂供应商集采单位',
    historyItem5Title: '业务稳健发展',
    historyItem5Date: '2021年',
    historyItem5Desc: '获得《一种基于人工智能及大数据的智能 区域种植方法及其系统》的发明专利证书<br/>获得3A企业信用等级证书<br/>成为绿城置业供应商集采单位<br/>成为中粮集团供应商集采单位',
    historyItem6Title: '成立景天下（北京） 景观设计有限公司',
    historyItem6Date: '2022年-2023年',
    historyItem6Desc: '成为华润集团集采单位<br/>成为绿城中国的园林景观集采单位<br/>被评为专精特新企业<br/>获得北京林学会、北京昌平文化创意产业中心等多个奖项<br/>获得创新管理体系认证等相关证书',
    historyItem7Title: '数字化转型',
    historyItem7Date: '2024年-至今',
    historyItem7Desc: '成立景天下（北京）科技有限公司<br/>成为中国金茂华北区域供应商集采单位<br/>成为中国金茂华中区域供应商集采单位<br/>成为广州保利供应商集采单位<br/>成为泰康人寿供应商集采单位',
    historyStat1Label: '地方标准',
    historyStat2Label: '行业奖项',
    historyStat3Label: '软件著作',
    historyStat4Label: '发明专利',
    historyGalleryTitle: '发展历程图片',
    historyGallery1Caption: '公司成立',
    historyGallery2Caption: '成立智慧景观研发部',
    historyGallery3Caption: '开启智慧景观',
    historyGallery4Caption: '确定景天下 “智慧景观” 的发展战略',
    historyGallery5Caption: '成立景天下（北京） 景观设计有限公司',
    historyGallery6Caption: '数字化转型',
    // 管理团队页
    teamPageTitle: '我们的管理团队',
    teamPageDesc: '我们的团队由行业资深专家组成，拥有丰富的经验和创新精神，致力于为客户提供最优质的产品和服务。',
    teamLoading: '加载团队成员数据中...',
    teamEmpty: '暂无团队成员信息',
    teamNoBio: '暂无简介',
    teamLoadError: '获取团队成员失败',
    teamLoadRetryError: '获取团队成员数据失败，请稍后再试',
    teamRoleManagement: '公司管理层',
    teamRoleDeptHead: '部门负责人',
    teamRoleExpert: '技术专家',
    teamRoleMember: '团队成员',
    teamDepartmentsTitle: '我们的专业团队',
    teamDepartmentsDesc: '各个部门由优秀人才组成，协同工作，为企业发展提供强大支持。',
    teamStaffCount: '团队人数',
    teamProjectsCompleted: '完成项目',
    teamCoreMembers: '核心成员',
    teamDept1Name: '研发部',
    teamDept1Desc: '负责产品研发和技术创新，致力于打造高质量的产品和服务。',
    teamDept1Member1Name: '李明', teamDept1Member1Position: '首席技术官',
    teamDept1Member2Name: '张伟', teamDept1Member2Position: '架构师',
    teamDept1Member3Name: '王芳', teamDept1Member3Position: '技术经理',
    teamDept1Member4Name: '刘洋', teamDept1Member4Position: '高级开发工程师',
    teamDept2Name: '市场部',
    teamDept2Desc: '负责市场推广和品牌建设，制定有效的营销策略，提升品牌影响力。',
    teamDept2Member1Name: '王丽', teamDept2Member1Position: '首席营销官',
    teamDept2Member2Name: '张明', teamDept2Member2Position: '市场总监',
    teamDept2Member3Name: '李娜', teamDept2Member3Position: '品牌经理',
    teamDept2Member4Name: '赵阳', teamDept2Member4Position: '营销策划',
    teamDept3Name: '产品部',
    teamDept3Desc: '专注于产品设计和用户体验优化，深入了解用户需求，打造卓越产品。',
    teamDept3Member1Name: '陈晓', teamDept3Member1Position: '产品总监',
    teamDept3Member2Name: '王悦', teamDept3Member2Position: '用户体验设计师',
    teamDept3Member3Name: '张峰', teamDept3Member3Position: '产品经理',
    teamDept3Member4Name: '李婷', teamDept3Member4Position: '交互设计师',
    teamCultureTitle: '企业文化与价值观',
    teamValue1Title: '创新',
    teamValue1Desc: '不断探索新技术、新方法，推动行业发展。',
    teamValue2Title: '卓越',
    teamValue2Desc: '追求卓越品质，精益求精，为客户创造最大价值。',
    teamValue3Title: '协作',
    teamValue3Desc: '团队协作，共同成长，实现集体智慧的最大化。',
    teamValue4Title: '诚信',
    teamValue4Desc: '诚实守信，言行一致，赢得客户和合作伙伴信任。',
    teamJoinTitle: '加入我们的团队',
    teamJoinDesc: '我们始终寻找优秀的人才加入团队，共同创造美好未来。',
    teamViewJobs: '查看职位',
    // 组织架构页
    orgTitle: '企业组织架构',
    orgDesc: '我们拥有完善的组织管理体系，确保企业高效运转，为客户提供最优质的服务和产品。',
    orgLoading: '加载组织架构数据中...',
    orgEmpty: '暂无组织架构数据',
    orgLoadError: '获取组织架构失败',
    orgLoadRetryError: '获取组织架构数据失败，请稍后再试',
    orgMembersTitle: '部门成员',
    orgDutiesTitle: '部门职责说明',
    orgDept1Title: '总裁办公室',
    orgDept1Desc: '负责公司战略规划、业务协调、资源分配、决策执行等工作，是公司的核心管理机构。',
    orgDept1Duty1: '制定和实施公司发展战略',
    orgDept1Duty2: '协调各部门工作，提高运营效率',
    orgDept1Duty3: '负责企业文化建设和企业形象维护',
    orgDept1Duty4: '监督和评估公司业务执行情况',
    orgDept2Title: '管理层',
    orgDept2Desc: '公司核心决策层，负责公司整体战略方向和重大决策的制定与执行。',
    orgDept2Duty1: '制定公司发展战略和年度目标',
    orgDept2Duty2: '监督公司整体运营状况',
    orgDept2Duty3: '审批重大决策和投资计划',
    orgDept2Duty4: '统筹协调各部门工作',
    orgDept3Title: '技术部门',
    orgDept3Desc: '负责产品技术研发、架构设计、技术创新等工作，是企业核心竞争力的重要组成部分。',
    orgDept3Duty1: '技术架构设计与实现',
    orgDept3Duty2: '产品开发与维护',
    orgDept3Duty3: '技术创新和研究',
    orgDept3Duty4: '技术文档编写与管理',
    orgDept3Duty5: '技术支持和问题解决',
    orgDept4Title: '市场部门',
    orgDept4Desc: '负责市场调研、品牌推广、销售策略、客户开发等工作，拓展企业市场份额。',
    orgDept4Duty1: '市场调研与分析',
    orgDept4Duty2: '品牌建设与推广',
    orgDept4Duty3: '销售策略制定与执行',
    orgDept4Duty4: '客户开发与维护',
    orgDept4Duty5: '营销活动策划与实施',
    orgDept5Title: '财务部门',
    orgDept5Desc: '负责公司财务管理、资金调配、预算编制、成本控制等工作，确保企业财务健康运行。',
    orgDept5Duty1: '负责企业会计核算和财务管理',
    orgDept5Duty2: '编制和执行企业预算',
    orgDept5Duty3: '进行成本分析和控制',
    orgDept5Duty4: '管理企业投资和融资活动',
    orgDept5Duty5: '税务筹划和管理',
    orgDept6Title: '人力资源部',
    orgDept6Desc: '负责人才招聘、培训发展、绩效管理、薪酬福利等工作，为企业发展提供人才保障。',
    orgDept6Duty1: '招聘和配置人才资源',
    orgDept6Duty2: '员工培训和职业发展规划',
    orgDept6Duty3: '绩效评估和激励机制建设',
    orgDept6Duty4: '薪酬福利管理',
    orgDept6Duty5: '企业文化建设与员工关系管理',
    orgDept7Title: '法务部门',
    orgDept7Desc: '负责企业法律事务、合同管理、知识产权保护等工作，降低企业法律风险。',
    orgDept7Duty1: '企业法律事务处理',
    orgDept7Duty2: '合同审核与管理',
    orgDept7Duty3: '知识产权保护',
    orgDept7Duty4: '法律风险防范',
    orgDept7Duty5: '法律咨询与支持',
    // 企业荣誉页
    honorsTitle: '我们的荣誉与资质',
    honorsDesc: '多年来，我们凭借卓越的产品和服务获得了广泛认可，荣获众多行业荣誉和资质认证。',
    honorsWallTitle: '企业荣誉',
    honorsCertsTitle: '资质认证',
    honorsCertNumberLabel: '证书编号:',
    honorsCertDateLabel: '获得日期:',
    honorsIssuerLabel: '发证机构:',
    honorsIssueDateLabel: '发证日期:',
    honorsValidUntilLabel: '有效期至:',
    honorsCertDescTitle: '证书说明',
    honorsDialogTitle: '证书详情',
    honorsIssuerPrefix: '颁发机构：',
    honorsPartnersTitle: '战略合作伙伴',
    honorsPartnersDesc: '多年来，我们与行业内众多知名企业建立了战略合作关系，共同为客户提供更优质的服务和产品。'
  },
  touch: {
    subtitle: '随时与我们取得联系，我们期待您的反馈',
    bannerTitle: '让沟通更简单',
    bannerDesc: '无论您有任何问题、建议或合作意向，我们都随时准备倾听',
    contactInfoTitle: '联系方式',
    addressLabel: '公司地址',
    address: '北京市昌平区王府街21号宝隆艺园50号楼203室',
    phoneLabel: '联系电话',
    emailLabel: '电子邮箱',
    workTimeLabel: '工作时间',
    workTime: '周一至周五: 9:00-18:00',
    followUs: '关注我们',
    environmentTitle: '公司环境',
    messageTitle: '在线留言',
    messageDesc: '如果您有任何问题或建议，请填写以下表单，我们会尽快回复您',
    faqTitle: '常见问题',
    faqDesc: '以下是客户常见的一些问题，希望能够帮助到您',
    faq1Question: '如何联系你们的客服团队？',
    faq1Answer: '您可以通过以上提供的电话、邮箱与我们联系，也可以通过在线留言表单提交您的问题，我们的客服团队会在24小时内回复您。',
    faq2Question: '你们提供上门服务吗？',
    faq2Answer: '是的，对于企业客户，我们提供上门技术支持和咨询服务，具体可与我们的客户经理联系安排。',
    faq3Question: '如何申请产品演示？',
    faq3Answer: '您可以通过在线留言表单申请产品演示，或直接致电我们的销售部门。我们会安排专业的产品经理为您提供详细的产品演示。',
    faq4Question: '你们的售后服务政策是什么？',
    faq4Answer: '我们为所有产品提供至少1年的免费技术支持和维护服务，部分产品可延长至3年。同时，我们提供7×24小时的紧急技术支持服务。'
  },
  boxs: {
    subtitle: '景天下科技专业解决方案',
    bannerTitle: '专业解决方案，助力企业发展',
    bannerDesc: '景天下科技为您提供全方位的技术服务与解决方案',
    searchResults: '搜索结果',
    searchPlaceholder: '搜索业务领域关键词',
    empty: '暂无相关业务',
    featuredTitle: '热门业务',
    featuredDesc: '我们的核心业务领域',
    catEnterprise: '企业服务',
    catInnovation: '技术创新',
    catInfrastructure: '数字基础设施',
    otherCategory: '其他业务',
    noSummary: '暂无简介',
    fallback1Title: '智慧监控',
    fallback1Content: '为企业提供全方位的信息化解决方案，包括ERP系统实施、企业内部网络建设、信息安全保障等服务，助力企业数字化转型。',
    fallback2Title: '智慧诊断',
    fallback2Content: '根据企业特定需求，提供专业的软件定制开发服务，涵盖需求分析、架构设计、编码实现、测试部署等全流程，打造专属的软件系统。',
    fallback3Title: '智慧管理',
    fallback3Content: '利用人工智能、机器学习、深度学习等技术，为企业开发智能化应用系统，如客服机器人、智能辅助决策系统、预测分析工具等。',
    fallback4Title: '智慧空间',
    fallback4Content: '提供大数据采集、存储、处理、分析与应用的一站式服务，帮助企业从海量数据中挖掘有价值的信息，支持业务决策。',
    fallbackServerMsg: '服务器暂时不可用，显示备用数据',
    fallbackConnMsg: '无法连接到服务器，显示备用数据',
    detailSubtitle: '易凡科技专业解决方案',
    shareTo: '分享至:',
    relatedTitle: '相关业务',
    contactAddress: '甘肃省兰州市皋兰县海河街6号',
    consultNow: '立即咨询',
    projectsSubtitle: '景天下科技桥体智慧绿化标杆项目案例',
    // ===== 经典案例（/boxs/projects 单页呈现）=====
    projectsIntro: '景天下坚持技术实战落地，以北京四环路月季花环系列项目为标杆，打造一批桥体智慧绿化、AI管养示范样板，业务从北京向外埠城市复制输出，形成可标准化推广的智慧园林实践成果。',
    solutionLabel: '解决方案',
    // 案例 01 北京·木樨地桥
    case1Title: '北京·木樨地桥智慧化示范项目',
    case1Loc: '北京',
    case1Intro: '木樨地桥是北京核心示范段，全长2.8公里，针对高架桥花箱高空养护风险高、大水漫灌水资源浪费、人工巡检效率低等痛点，落地智圃AI管养系统完整闭环方案，项目稳定运行660天。',
    case1Solution: '<li>划分26个独立灌溉分区，实现分时分区精准灌溉；部署22套土壤温湿度传感器，每5分钟采集环境数据，28台电磁阀执行精准控水</li><li>漏水故障自动预警、精准定位，减少高空占道检修作业</li><li>搭建可视化大数据中控平台，PC管理端+小程序移动端，全量监控设备运行、土壤墒情、灌溉水量</li><li>AI预测模型+气象数据联动，降雨前自动暂停灌溉，高温场景提前预灌溉</li>',
    case1Result: '<li>对比传统人工浇灌，管养成本降幅90%，每年节约成本118.4万元</li><li>大幅节水，积累279万+条环境运行数据，为桥体绿化智慧管养提供实测依据</li><li>实现每一株月季生长状态可监测，从经验养护升级为数据驱动科学管养</li>',
    case1ImgAlt: '北京木樨地桥智慧化示范项目实景',
    case1ImgCap: '北京·木樨地桥 桥体智慧绿化核心示范段',
    // 案例 02 北京·东四环
    case2Title: '北京·东四环智慧化提升项目',
    case2Loc: '北京',
    case2Intro: '基于木樨地桥成熟实践经验，面向东四环环路桥体复杂工况进行技术迭代升级，服务四环路月季花环全线景观建设，推动传统粗放式养护向精准科学模式转型。',
    case2Solution: '<li>新增水肥一体化泵站，实现水肥按需精准供给</li><li>升级有线阀控硬件，提升桥区车流、钢筋强干扰环境下系统稳定性</li><li>部署雨情感知设备，落地"降雨停灌补灌"三段式联动策略</li><li>增设小型气象站，采集温湿度、风速、蒸发量，为AI养护决策提供多源环境数据</li>',
    case2Result: '进一步完善环路桥体智慧管养技术体系，为四环路全线AI管养建设提供成熟技术范本，保障超长环线景观长效稳定呈现。',
    case2ImgAlt: '北京东四环路桥体绿化实景',
    case2ImgCap: '北京·东四环 桥体智慧绿化全线提升',
    // 案例 03 天津·复康路
    case3Title: '天津·复康路立交桥智慧绿化工程',
    case3Loc: '天津',
    case3Intro: '天津绿化中心实地考察北京木樨地桥样板后引入智圃AI管养整套方案，项目全长8公里，实现设计、施工、花箱制作、软硬件一体化全流程交付，打造天津桥体智慧绿化标杆。另有15座桥梁完成前期踏勘，待开展智慧化改造。',
    case3Solution: '完整复用北京桥体智慧绿化成熟模式：定制适配本地工况智慧花箱、物联网感知网络、智圃AI管养平台，实现桥体花卉远程精准灌溉、设备故障预警、数字化台账管理。',
    case3Result: '标志北京桥体AI管养模式成功跨地域复制，为北方城市快速路、立交桥绿化长效运维提供可借鉴样板。',
    case3ImgAlt: '天津复康路立交桥智慧绿化实景',
    case3ImgCap: '天津·复康路立交桥 桥体智慧绿化标杆',
    // 案例 04 杭州·拱墅区
    case4Title: '杭州·拱墅区桥体绿化智慧化合作项目',
    case4Loc: '杭州',
    case4Intro: '与杭州拱墅区开展合作，将智圃AI管养系统对接杭州城市大脑3.0，填补桥体绿化管养场景数字化空白，和"云上坦途"路面感知体系形成互补，构建路面桥体绿化全域感知网络。',
    case4Solution: '打通城市大脑数据接口，桥体绿化环境、设备、植物状态数据接入城市数字平台，实现城市级统一监管。',
    case4Result: '探索长三角城市桥体绿化数字化建设路径，打造南方城市智慧桥体绿化的可复制样板。',
    // ===== 业务概览（/boxs 首页静态呈现）=====
    overviewTitle: '业务概览',
    overviewIntro: '景天下生态环境科技，深耕园林景观与智慧生态领域15年，融合园林工程实践、物联网、云计算与植物AI大模型，打通规划设计→建设→AI智慧管养→标准输出全链条，面向市政路桥、城市绿地、公园园区、庭院微景观等多元场景，提供软硬件一体化智慧园林综合解决方案，破解传统绿化高危作业、高成本、经验化养护痛点，实现景观效果可持续、管养安全降本增效，打造可复制、标准化的城市生态数字化样板。',
    capabilitiesLabel: '核心能力',
    valueLabel: '项目价值',
    resultLabel: '落地成效',
    productSeriesLabel: '产品系列',
    galleryLabel: '产品实景',
    // 模块 01 桥体环线
    bridgeTitle: '城市桥体环线智慧绿化',
    bridgeIntro: '以北京四环路月季花环、木樨地桥示范段为标杆实践，聚焦高架、立交桥、城市快速环路桥体绿化场景，解决桥体高空高危作业、交通管制成本高、大水漫灌水资源浪费、桥梁荷载约束、设备运维困难等行业痛点。提供从前期荷载复核、花箱系统设计、工程施工、软硬件部署到AI长效管养的一站式落地服务，打造安全、美观、可持续的桥体景观名片。',
    bridgeCapabilities: '<li><strong>桥体绿化专项工程</strong>：花箱体系、托架锚固、管线给排水系统一体化实施，充分兼顾桥梁结构安全与抗风防坠安全</li><li><strong>智圃AI桥体管养系统落地</strong>：感知→决策→执行→反哺四层闭环体系，土壤墒情、雨量、流量多源数据实时采集</li><li><strong>分区精准水肥管控</strong>：降雨联动自动停灌，漏水故障精准预警，大幅减少人员上桥高危作业频次</li><li><strong>已落地标杆项目</strong>：北京木樨地桥、东四环、天津复康路立交桥等，技术模式向外省市复制输出</li>',
    bridgeValue: '实测实现管养成本大幅下降，节水降耗，降低高空作业安全风险，让桥体景观长期稳定出彩，打造城市辨识度景观地标。',
    bridgeImgAlt: '北京四环路月季花环实拍',
    bridgeImgCap: '北京四环路桥体月季花环示范段',
    // 模块 02 智圃AI
    aiparkTitle: '智圃AI智慧园林管养系统',
    aiparkIntro: '我司牵头起草北京市地方标准《城镇绿地智慧养护系统建设技术规范》DB11/T 2467-2025，智圃AI管养系统严格遵循标准研发，是面向植物全生命周期的闭环智慧管养平台，推动园林养护从"经验驱动"转向"数据+AI驱动"。',
    aiparkCapabilities: '<li><strong>四层闭环技术架构：感知→决策→执行→反哺</strong>。感知层（眼睛）部署土壤温湿度、气象、流量等多类传感器；决策层（大脑）依托自研植物大模型知识库，结合AI预测模型与气象接口生成养护方案；执行层（手脚）通过电磁阀、水肥一体化泵站等智能硬件完成远程自动控制；反哺层（进化）让养护数据回流训练模型，系统越用越智能</li><li><strong>多端数字化管理</strong>：可视化中控大屏、PC管理端、小程序移动端，实现设备监控、告警推送、养护台账、数据统计分析，每一株植物生长状态可追溯</li><li><strong>六大核心服务</strong>：智慧监测、智慧诊断、智慧灌溉、智慧施肥、有害生物防治、智慧管理</li><li><strong>适配场景</strong>：城市环路、高架桥、城市绿地、公园、道路隔离带等市政绿化场景</li>',
    aiparkResult: '木樨地桥示范段稳定运行660天，成本降幅达90%，灌溉节水效果显著，故障自动预警，养护工作可量化、可考核。',
    aiparkImgAlt: '智圃AI四层闭环技术架构图',
    aiparkImgCap: '感知→决策→执行→反哺 四层闭环',
    // 模块 03 智慧硬件
    hardwareTitle: '智慧硬件产品体系',
    hardwareIntro: '自研全系列智慧园林硬件产品，软硬深度适配，覆盖市政大型工程到庭院小微场景，硬件稳定抗干扰，适配城市复杂工况。',
    hardwareProducts: '<li><strong>小圃智慧花箱系列</strong>：AI管养一体化花箱，适配高架桥、道路隔离带，兼顾结构安全、排水、防坠，内置传感与执行单元，可自由组合，快速接入智圃AI平台，广泛应用于环路月季花环类桥体项目</li><li><strong>小圃庭院系列</strong>：面向园区、庭院、室内外微景观，包含智能网关、智能灌溉控制器、移动端小程序，实现家庭/小场地植物智慧管养</li><li><strong>智慧泵站与阀控设备</strong>：水肥一体化泵站、高稳定性有线阀控设备，钢筋水泥车流干扰的桥区环境下保障系统可靠运行，实现分区分时水肥供给</li><li><strong>环路智能巡检养护机器人工作站（RaaS机器人即服务）</strong>：面向城市主干道、快速路隔离带养护痛点，融合北斗导航、AI机器视觉、双机械臂，支持修剪、杂草清除、靶向喷药等作业，毫米级作业精度，替代高危人工作业，以服务化模式优化市政预算</li>',
    hardwareImg1Alt: '小圃智慧花箱 单盆实物',
    hardwareImg1Cap: '小圃智慧花箱系列 — 适配桥体/隔离带',
    hardwareImg2Alt: '大型一体化花箱阵列',
    hardwareImg2Cap: '市政级花箱阵列快速部署',
    hardwareImg3Alt: '小圃庭院系列智慧花箱',
    hardwareImg3Cap: '小圃庭院系列 — 园区/家庭场景',
    // 模块 04 园林工程
    engineeringTitle: '园林景观工程全链条服务',
    engineeringIntro: '15年园林行业积淀，具备规划、景观设计、工程施工、落地运维一体化能力，兼顾传统景观美学与智慧化前置设计。在项目前期即融入智慧管养理念，避免"重建设、轻运维"，实现建好也能养好。',
    engineeringImgAlt: '永定河休闲森林公园景观',
    engineeringImgCap: '永定河休闲森林公园 智慧化景观样板'
  },
  product: {
    title: '产品展示',
    subtitle: '景天下科技创新产品与解决方案',
    allProducts: '全部产品',
    catSoftware: '软件产品',
    catHardware: '硬件设备',
    catSolution: '解决方案',
    catService: '技术服务',
    empty: '暂无产品',
    noIntro: '暂无简介',
    featuredTitle: '推荐产品',
    featuredDesc: '易凡科技精选解决方案',
    learnMore: '了解详情',
    socialRespSubtitle: '景天下科技企业社会责任',
    socialRespIntro: '景天下生态环境科技坚守“科技赋能生态，共建美好城市”的企业责任，把社会责任融入技术研发、项目建设、运营服务全流程。立足生态文明建设，以技术创新守护城市绿色空间，践行低碳节水、安全生产、行业共建、人才培养，实现商业价值、生态效益与社会效益协同发展。',
    // 四大责任板块（卡片精简版）
    socialRespGreenTitle: '生态低碳责任',
    socialRespGreenDesc: 'AI 精准管养节约水资源，拓展城市绿色空间，助力城市低碳可持续发展。',
    socialRespSafetyTitle: '安全运维责任',
    socialRespSafetyDesc: '以数字化替代高危人工作业，降低桥体养护高空、占道作业安全风险。',
    socialRespStandardsTitle: '行业共建责任',
    socialRespStandardsDesc: '牵头编制地方行业标准，输出可复制实践样板，推动园林行业数字化升级。',
    socialRespPeopleTitle: '人才与社会担当',
    socialRespPeopleDesc: '培育复合型产业人才，产学研协同创新，建设市民共享的高品质城市生态景观。',
    // 四大责任板块详情（HTML 内容，v-html 渲染）
    socialRespGreenContent: '<p>践行<strong>双碳发展理念</strong>，以智慧技术破解传统绿化资源消耗痛点。通过智圃AI管养系统实现按需精准灌溉，减少大水漫灌带来的水资源浪费，降低养护作业车辆燃油消耗，从源头减少运维阶段碳排放。</p><p>以北京四环路月季花环等标杆项目，打造城市桥体立体绿化，拓展城市绿色空间，改善城市微气候，提升人居环境品质，让市民共享城市生态建设成果。</p><p>坚持绿色施工，项目实施中兼顾桥梁结构安全、生态保护，减少施工对城市交通与环境扰动，推动城市绿化建设走向低碳可持续。</p>',
    socialRespSafetyContent: '<p>传统桥体环路绿化养护存在高空作业、占道洒水、交通事故等多重安全隐患。公司通过AI智慧管养体系，用<strong>数字化、自动化手段替代大量人工高空、占道高危作业</strong>，减少人员暴露在风险工况的频次，降低市政养护作业安全事故风险。</p><p>硬件设备充分考虑桥体抗风、防坠、荷载约束，从设计源头规避安全隐患；设备故障自动预警、精准定位，减少盲目上路巡检，兼顾一线作业人员安全与城市道路通行安全。</p>',
    socialRespStandardsContent: '<p>作为北京市地方标准<strong>《城镇绿地智慧养护系统建设技术规范》（DB11/T 2467-2025）</strong>牵头起草单位，深度参与8项北京市地方标准编制，输出智慧园林建设的技术框架与实践经验。</p><p>开放项目实践成果，开展技术交流、经验分享，把北京桥体绿化AI管养实战经验向天津、杭州等外埠城市输出，打造可复制、可推广的智慧园林样板，推动整个园林养护行业从经验化走向标准化、数字化。</p><p>积极开展技术科普，分享智慧园林落地实践，助力行业整体能力提升。</p>',
    socialRespPeopleContent: '<p>坚持以人为本，重视技术人才、园林产业人才培养，打通传统园林与AI数字化技术人才融合发展通道，为智慧园林行业培育复合型专业人才。</p><p>积极参与城市花园城市建设，打造市民喜闻乐见的城市景观名片，提升群众获得感与幸福感；积极探索产学研协同，联动科研院所开展植物大模型、园林智能装备研发，以<strong>科技创新赋能城市生态治理</strong>。</p><p>恪守商业道德，坚持诚信经营，严守工程质量，以高品质项目回馈社会。</p>',
    // 详情页小文案
    socialRespNotExists: '该板块不存在',
    socialRespBackToList: '返回社会责任',
    socialRespPrev: '上一板块',
    socialRespNext: '下一板块',
    innovationTitle: '创新发展',
    innovationSubtitle: '景天下科技创新技术与研发',
    innovationIntro: '作为国家级高新技术、专精特新企业，景天下坚持“园林为本、科技为核”，打通技术研发—产品迭代—项目实证—标准输出完整创新链路，将物联网、AI大模型、智能装备与传统园林深度融合，破解城市桥体绿化、市政绿地养护行业痛点，以技术创新驱动园林行业数字化转型，实现技术从实验室走向真实市政项目落地。',
    // 五大创新板块（卡片精简版）
    innovationTechTitle: '技术体系创新',
    innovationTechDesc: '感知决策执行反哺四层闭环，植物大模型赋能，推动园林养护从经验驱动转向AI数据驱动。',
    innovationProductsTitle: '软硬件产品创新',
    innovationProductsDesc: '自研智慧花箱、阀控设备、环路养护机器人，适配桥体高危复杂市政工况。',
    innovationStandardsTitle: '标准与模式创新',
    innovationStandardsDesc: '牵头编制地方行业标准，打造可跨城市复制的桥体智慧绿化样板。',
    innovationIpTitle: '知识产权与产学研创新',
    innovationIpDesc: '多项发明专利、软件著作权，产学研协同，以真实项目持续迭代技术。',
    innovationBusinessTitle: '商业模式创新',
    innovationBusinessDesc: '产品平台服务多元模式，提供新建、改造、RaaS服务、数字化托管综合服务。',
    // 五大创新板块详情（HTML 内容，v-html 渲染）
    innovationTechContent: '<p>首创面向桥体环路绿化的<strong>四层闭环智圃AI管养技术体系</strong>：感知层、决策层、执行层、反哺层。</p><p>以自研植物大模型知识库为核心大脑，沉淀海量植物生长习性、病害、环境适配数据；融合土壤墒情、气象、流量多源物联网感知数据，结合AI预测算法，联动气象预报动态生成养护策略；通过智能硬件完成灌溉、施肥精准执行；业务数据持续回流迭代模型，形成“越用越智能”的自进化闭环。</p><p>打破传统园林“靠老师傅经验”的模式，把植物专家经验数字化，实现每一株植物<strong>“一物一策”</strong>精细化管养。</p>',
    innovationProductsContent: '<p>坚持<strong>软硬件一体化自研</strong>，针对高架桥、城市环路等钢筋密布、强干扰、高空受限的特殊场景，开发系列适配产品：</p><ul><li><strong>智慧花箱系统</strong>：兼顾桥梁荷载验算、抗风防坠、排水透气，内置传感与控制单元，解决桥体绿化安全与智慧化双重需求；</li><li><strong>高稳定性阀控与水肥一体化设备</strong>：有线抗干扰控制方案，适配桥区复杂电磁环境，保障超长环路系统稳定运行；</li><li><strong>环路巡检养护机器人工作站</strong>：创新RaaS机器人即服务模式，双机械臂、AI视觉识别，实现修剪、除草、靶向施药，替代高危人工作业；</li><li><strong>智圃庭院系列产品</strong>：将市政级AI管养能力下沉至园区、庭院小微绿化场景，实现技术能力全域复用。</li></ul>',
    innovationStandardsContent: '<p>牵头起草北京市地方标准<strong>《城镇绿地智慧养护系统建设技术规范》（DB11/T 2467-2025）</strong>，深度参与8份北京市地方标准编制，把项目实战经验上升为行业标准，填补国内城镇绿地AI智慧养护标准空白。</p><p>创新<strong>“北京样板+异地复制”</strong>落地模式，以北京四环路月季花环、木樨地桥为实证底座，技术输出至天津、杭州等城市；打通与城市大脑的数据对接通道，实现桥体绿化数字化能力融入智慧城市底座，形成可标准化、可输出的解决方案范式。</p>',
    innovationIpContent: '<p>公司拥有<strong>16项发明专利、11项软件著作权</strong>，构建完整知识产权保护体系。持续加大研发投入，组建“园林+AI”跨学科复合型研发团队，打通园林生态、物联网、人工智能多领域人才融合。</p><p>联动园林科研院所开展产学研协同创新，围绕桥体绿化、植物AI诊断、智慧装备开展联合研究；依托北京木樨地桥<strong>660天连续实测</strong>，积累海量真实工况数据集，持续迭代优化算法与硬件产品，坚持<strong>“项目即是试验场，落地即是验证”</strong>。</p>',
    innovationBusinessContent: '<p>突破传统园林工程单一建设模式，拓展<strong>“产品+平台+服务”</strong>多元化服务模式：</p><ul><li><strong>新建项目</strong>：前期规划阶段前置智慧管养设计，避免“重建设、轻运维”；</li><li><strong>存量升级</strong>：对既有绿地、桥体绿化开展智慧化改造；</li><li><strong>RaaS机器人即服务</strong>：以服务化模式提供智能养护装备能力，优化市政财政预算；</li><li><strong>数字化运维托管</strong>：依托智圃AI平台，输出长期数字化管养运营服务。</li></ul>',
    // 详情页小文案
    innovationNotExists: '该板块不存在',
    innovationBackToList: '返回创新发展',
    innovationPrev: '上一板块',
    innovationNext: '下一板块',
    servicesTitle: '主营业务',
    servicesSubtitle: '景天下科技核心业务板块',
    servicesIntro: '景天下立足 15 年园林行业积淀，融合园林工程实践、物联网、云计算与植物 AI 大模型，围绕建设+管养双主线，形成五大主营业务，为市政及各类客户提供一体化智慧园林综合解决方案，解决传统绿化高危作业、成本高昂、经验化养护等痛点，输出标准化、可复制的落地成果。',
    // 五大业务板块（卡片精简版）
    servicesBridgeTitle: '城市桥体环线智慧绿化',
    servicesBridgeDesc: '桥体景观工程 + AI 长效管养一站式落地，解决高空养护痛点，打造城市地标级绿化景观。',
    servicesAiparkTitle: '智圃 AI 智慧园林管养系统',
    servicesAiparkDesc: '遵循北京地方标准，四层闭环 AI 平台，植物大模型赋能，实现绿化全生命周期数字化管养。',
    servicesHardwareTitle: '自研智慧园林硬件产品',
    servicesHardwareDesc: '智慧花箱、水肥泵站、庭院套件、巡检养护机器人，软硬协同适配各类复杂园林工况。',
    servicesEngineeringTitle: '园林景观全链条工程',
    servicesEngineeringDesc: '规划设计施工运维一体化，新建项目智慧前置，存量绿地智慧升级改造。',
    servicesStandardsTitle: '标准共建与技术赋能',
    servicesStandardsDesc: '参编地方行业标准，输出技术方案与可复制样板，赋能行业数字化转型升级。',
    // 五大业务板块详情（HTML 内容，v-html 渲染）
    servicesBridgeContent: '<p>聚焦高架桥、立交桥、城市快速环路等高难度桥体绿化场景，以北京四环路月季花环、木樨地桥为标杆项目，提供方案设计、安全化花箱工程施工、智慧软硬件部署、AI 长效管养全流程服务。</p><p>充分兼顾桥梁荷载、抗风防坠、交通安全约束，落地智圃 AI 管养体系，实现分区精准水肥、漏水故障预警，大幅减少高空占道高危作业。项目模式已落地天津、杭州等外埠城市，打造城市辨识度景观名片。</p>',
    servicesAiparkContent: '<p>作为北京市地方标准<strong>《城镇绿地智慧养护系统建设技术规范》（DB11/T 2467-2025）</strong>主要起草单位，自研智圃 AI 管养平台，构建<strong>感知、决策、执行、反哺</strong>四层闭环智慧体系。</p><p>依托植物大模型知识库，结合土壤、气象、流量多源传感器数据与 AI 预测模型，自动生成养护策略，实现精准灌溉、施肥、病虫害预警；配套可视化中控大屏、PC 端、小程序移动端，完成设备监控、告警推送、养护台账、数据分析，让园林养护从“凭经验”转向“靠数据”，适配环路桥体、道路绿地、公园等多种市政绿化场景。</p>',
    servicesHardwareContent: '<p>软硬一体化自研开发，硬件经过大量市政复杂工况验证，稳定性强，覆盖大型市政工程到小微庭院场景：</p><ul><li><strong>小圃智慧花箱系列</strong>：桥体环路专用一体化 AI 花箱，兼顾结构安全、排水防坠，内置传感与执行单元，可快速接入 AI 管养平台；</li><li><strong>水肥泵站与阀控设备</strong>：水肥一体化泵站、高抗干扰有线阀控设备，适配桥区车流、钢筋环境，保障系统稳定运行；</li><li><strong>小圃庭院系列</strong>：智能网关、灌溉控制器、小程序，面向园区、庭院、室内外微景观智慧管养；</li><li><strong>环路智能巡检养护机器人工作站</strong>：RaaS 机器人即服务模式，融合北斗导航、AI 视觉、双机械臂，完成修剪、除草、靶向喷药等作业，替代高危人工养护。</li></ul>',
    servicesEngineeringContent: '<p>具备规划、景观设计、施工、运维一体化实施能力，项目前期前置智慧管养理念，规避“重建设、轻运维”问题。</p><p>服务包含：城市桥体与环路景观营建、城市道路及公园绿地工程、存量绿地智慧化升级改造，同时配套现场踏勘、荷载验算、管线配套等专项技术服务。</p>',
    servicesStandardsContent: '<p>深度参与北京市地方行业标准编制，输出智慧园林建设的技术框架与实践经验。</p><p>开放项目实践成果，开展技术交流、经验分享，把北京桥体绿化 AI 管养实战经验向天津、杭州等外埠城市输出，打造可复制、可推广的智慧园林样板，推动整个园林养护行业从经验化走向标准化、数字化。</p><p>积极开展技术科普与产业赋能，分享智慧园林落地实践，助力行业整体能力提升。</p>',
    // 详情页小文案
    servicesNotExists: '该板块不存在',
    servicesBackToList: '返回主营业务',
    servicesPrev: '上一板块',
    servicesNext: '下一板块',
    // 板块图集
    servicesGalleryTitle: '项目实景',
    servicesBridgeImg1Alt: '北京四环路月季花环实拍',
    servicesBridgeImg1Cap: '北京四环路月季花环——桥体智慧绿化样板',
    servicesAiparkImg1Alt: '智圃 AI 智慧园林管养中控大屏',
    servicesAiparkImg1Cap: '智圃 AI 平台中控大屏：实时感知、告警与决策一体化',
    servicesHardwareImg1Alt: '桥体环路智能巡检养护机器人',
    servicesHardwareImg1Cap: '桥体环路智能巡检养护机器人：RaaS 双机械臂作业',
    servicesHardwareImg2Alt: '永定河休闲森林公园一体化花箱',
    servicesHardwareImg2Cap: '一体化智慧花箱：适配公园、园区多场景',
    servicesHardwareImg3Alt: '桥体挂壁花箱',
    servicesHardwareImg3Cap: '挂壁式花箱：兼容桥体、墙体立面绿化',
    servicesEngineeringImg1Alt: '永定河休闲森林公园景观',
    servicesEngineeringImg1Cap: '永定河休闲森林公园：规划、设计、施工、运维一体化'
  },
  docs: {
    title: '技术文档',
    subtitle: '易凡科技产品和服务的技术文档资料',
    allDocs: '全部文档',
    empty: '暂无相关文档',
    detailSubtitle: '技术文档详细内容',
    relatedTitle: '相关推荐',
    detailEmpty: '暂无文档信息'
  },
  recruits: {
    joinTitle: '加入我们',
    headerSubtitle: '与景天下科技一起创造未来',
    cultureTitle: '公司文化',
    cultureDesc: '在景天下科技，我们坚信人才是公司最宝贵的财富。我们致力于创造开放、包容、创新的工作环境，鼓励员工不断挑战自我，实现个人价值。',
    value1Title: '创新',
    value1Desc: '拥抱变化，勇于创新，推动科技进步',
    value2Title: '协作',
    value2Desc: '团队合作，共同成长，实现共赢',
    value3Title: '卓越',
    value3Desc: '追求卓越，精益求精，超越自我',
    value4Title: '诚信',
    value4Desc: '诚实守信，言行一致，负责任',
    categoriesTitle: '职位类别',
    categoriesDesc: '探索适合您的职业发展道路',
    whyJoinTitle: '加入我们的理由',
    whyJoinDesc: '我们提供具有竞争力的薪酬和完善的福利体系',
    benefit1Title: '具竞争力薪酬',
    benefit1Desc: '提供行业内具有竞争力的薪资水平和绩效奖金',
    benefit2Title: '五险一金',
    benefit2Desc: '为员工提供完善的社会保险和住房公积金',
    benefit3Title: '带薪年假',
    benefit3Desc: '除法定节假日外，享受额外带薪年假和弹性工作时间',
    benefit4Title: '培训发展',
    benefit4Desc: '提供专业技能培训和职业发展规划',
    benefit5Title: '团队活动',
    benefit5Desc: '定期组织团建活动和公司旅行',
    benefit6Title: '晋升机会',
    benefit6Desc: '透明的晋升机制和广阔的职业发展空间',
    processTitle: '申请流程',
    processDesc: '了解我们的招聘流程，做好充分准备',
    step1Title: '简历投递',
    step1Desc: '通过官网或招聘平台投递您的简历',
    step2Title: '简历筛选',
    step2Desc: 'HR团队初步筛选符合要求的简历',
    step3Title: '技术面试',
    step3Desc: '与技术团队进行专业能力面试',
    step4Title: '综合面试',
    step4Desc: '与部门负责人进行深入交流',
    step5Title: 'offer发放',
    step5Desc: '发放录用通知，确认入职事宜',
    contactDesc: '如有任何招聘相关问题，请随时与我们联系',
    contactEmailLabel: '招聘邮箱：',
    contactHotlineLabel: '招聘热线：',
    // ===== 职位类别（/recruits 静态呈现 + /recruits/jobs/:id 详情）=====
    jobsSubtitle: '景天下科技六大职业方向',
    positionsLabel: '涵盖岗位',
    // 6 类别（Recruits 卡片 + JobCategoryDetail 共用）
    jobRdTitle: '研发技术类',
    jobRdDesc: '聚焦智圃 AI 管养平台、植物大模型、物联网硬件、智能养护装备的技术研发与迭代，打通算法软件硬件现场落地全链路。',
    jobRdPositions: 'AI 算法工程师;后端开发工程师;前端开发工程师;嵌入式开发;硬件工程师;机械结构工程师;植物生态研发;数据工程师;测试工程师',
    jobLandscapeTitle: '园林工程技术类',
    jobLandscapeDesc: '衔接景观设计、项目实施、现场技术落地，兼顾传统园林专业能力与智慧化技术理解，服务桥体环线、市政绿地各类项目建设与现场实施。',
    jobLandscapePositions: '景观设计师;方案设计师;园林项目经理;现场工程师;园艺技术工程师;植物养护技术专家;资料员;荷载/结构专项技术工程师',
    jobSolutionTitle: '智慧解决方案与技术支持类',
    jobSolutionDesc: '面向市政客户输出智慧园林整体方案，完成项目售前、落地实施、运维技术服务，打通技术与业务场景。',
    jobSolutionPositions: '解决方案工程师;售前技术支持;项目实施工程师;物联网调试工程师;售后技术运维;标准编制专员',
    jobBusinessTitle: '市场商务类',
    jobBusinessDesc: '拓展智慧园林、桥体绿化业务市场，开展客户对接、招投标、商务合作、品牌推广，推动项目模式复制输出。',
    jobBusinessPositions: '销售经理;商务拓展;招投标专员;市场策划;品牌宣传;渠道合作专员',
    jobFunctionTitle: '职能管理类',
    jobFunctionDesc: '支撑公司整体运营，保障项目、人力、财务、行政体系高效运转。',
    jobFunctionPositions: '人力资源;财务会计;行政综合;采购供应链;质量安全管理',
    jobInternTitle: '实习校招类',
    jobInternDesc: '面向在校大学生开放实习、应届校招岗位，培养园林 + AI 跨领域复合型后备人才。',
    jobInternPositions: '研发实习生;设计实习生;工程助理实习生;技术支持实习生;市场运营实习生',
    // 详情页小文案
    jobsNotExists: '该职位类别不存在',
    jobsBackToList: '返回职位类别',
    jobsPrev: '上一类别',
    jobsNext: '下一类别',
    campusSubtitle: '易凡科技校园招聘计划',
    campusSectionDesc: '为青年才俊提供广阔的发展舞台',
    campusAlertDesc: '我们正在整理校园招聘信息，即将为您呈现',
    socialSubtitle: '易凡科技社会招聘信息',
    socialSectionDesc: '易凡科技期待优秀人才的加入',
    socialAlertDesc: '我们正在整理社会招聘信息，即将为您呈现',
    internSubtitle: '易凡科技实习生计划',
    internSectionTitle: '实习生计划',
    internSectionDesc: '为未来人才提供实践与成长的机会',
    internAlertDesc: '我们正在整理实习生招聘信息，即将为您呈现'
  },
  legal: {
    termsTitle: '使用条款',
    lastUpdated: '最后更新日期：2023年11月20日',
    companyLabel: '公司名称：',
    companyValue: 'XX科技有限公司',
    addressLabel: '地址：',
    addressValue: '北京市海淀区科技园区XX号',
    emailLabel: '电子邮件：',
    privacyEmail: "privacy{'@'}example.com",
    termsEmail: "legal{'@'}example.com",
    phoneLabel: '电话：',
    phoneValue: '400-123-4567',
    privacy: {
      sec1Title: '1. 引言',
      sec1P1: '欢迎访问我们的网站。本隐私政策旨在向您说明我们如何收集、使用、披露和保护您的个人信息。我们尊重您的隐私，并致力于保护您的个人信息安全。',
      sec1P2: '请您在使用我们的服务前仔细阅读本隐私政策。当您访问我们的网站或使用我们的服务时，即表示您已了解并同意本隐私政策中描述的数据实践。',
      sec2Title: '2. 信息收集',
      sec2P1: '我们可能会收集以下类型的信息：',
      sec21Title: '2.1 您主动提供的信息',
      sec21P1: '当您注册账户、订阅我们的服务、填写联系表单、参与调查或以其他方式与我们交流时，您可能会向我们提供以下信息：',
      sec21Item1: '个人身份信息：如姓名、电子邮件地址、电话号码、邮寄地址等',
      sec21Item2: '账户凭据：如用户名和密码',
      sec21Item3: '付款信息：如信用卡详细信息或银行账户信息',
      sec21Item4: '通信内容：如您与我们客户服务团队的沟通内容',
      sec22Title: '2.2 自动收集的信息',
      sec22P1: '当您访问我们的网站或使用我们的服务时，我们可能会自动收集以下信息：',
      sec22Item1: '设备信息：如设备类型、操作系统版本和浏览器类型',
      sec22Item2: '使用数据：如访问时间、停留时间和查看的页面',
      sec22Item3: 'IP地址和位置信息',
      sec22Item4: 'Cookies和类似技术收集的信息',
      sec3Title: '3. 信息使用',
      sec3P1: '我们可能会将收集到的信息用于以下目的：',
      sec3Item1: '提供、维护和改进我们的服务',
      sec3Item2: '处理和完成交易',
      sec3Item3: '发送与您账户或交易相关的通知',
      sec3Item4: '发送营销和促销信息（如您选择接收）',
      sec3Item5: '响应您的评论、问题和请求',
      sec3Item6: '定制您的体验并提供个性化内容',
      sec3Item7: '监控和分析网站使用情况和趋势',
      sec3Item8: '防止欺诈和保障安全',
      sec3Item9: '遵守法律义务',
      sec4Title: '4. 信息共享',
      sec4P1: '我们可能会在以下情况下共享您的个人信息：',
      sec4Item1Label: '服务提供商：',
      sec4Item1Text: '与帮助我们运营业务和提供服务的第三方服务提供商共享，如支付处理商、云服务提供商等',
      sec4Item2Label: '业务伙伴：',
      sec4Item2Text: '与我们合作提供产品或服务的业务伙伴共享，但仅在您同意的情况下',
      sec4Item3Label: '法律要求：',
      sec4Item3Text: '当我们有合理理由相信披露是法律要求的或必要的，以保护我们的权利、财产或安全，或他人的权利、财产或安全',
      sec4Item4Label: '企业交易：',
      sec4Item4Text: '在并购、出售资产、融资或我们业务的全部或部分被收购的情况下，作为交易的一部分',
      sec4P2: '我们不会出售您的个人信息给第三方。',
      sec5Title: '5. 数据安全',
      sec5P1: '我们采取合理的物理、技术和管理措施来保护您的个人信息免遭未经授权的访问、使用或披露。然而，没有任何互联网传输或电子存储方法是100%安全的。因此，虽然我们努力使用商业上可接受的方式保护您的个人信息，但我们不能保证其绝对安全。',
      sec6Title: '6. Cookie和类似技术',
      sec6P1: '我们使用Cookies和类似技术来收集和存储关于您访问我们网站的信息。Cookies是存储在您的浏览器或设备上的小型数据文件，允许我们记住您的偏好和设置，帮助我们了解您如何使用我们的服务，并提供个性化的体验。',
      sec6P2: '您可以通过修改浏览器设置来控制Cookies。然而，禁用Cookies可能会影响我们网站的功能和您的用户体验。',
      sec7Title: '7. 您的权利和选择',
      sec7P1: '根据适用的数据保护法律，您可能拥有以下权利：',
      sec7Item1: '访问您的个人信息',
      sec7Item2: '更正不准确或不完整的信息',
      sec7Item3: '删除您的个人信息',
      sec7Item4: '限制或反对处理您的个人信息',
      sec7Item5: '数据可携带性',
      sec7Item6: '撤回同意',
      sec7P2: '要行使这些权利，请通过下方"联系我们"部分提供的联系方式与我们联系。',
      sec8Title: '8. 儿童隐私',
      sec8P1: '我们的服务不面向13岁以下的儿童。我们不会故意收集13岁以下儿童的个人信息。如果您是父母或监护人，并且您认为您的孩子向我们提供了个人信息，请通过下方"联系我们"部分提供的联系方式与我们联系。',
      sec9Title: '9. 第三方链接',
      sec9P1: '我们的网站可能包含指向第三方网站、服务或应用程序的链接。点击这些链接或启用这些连接可能会允许第三方收集或共享关于您的数据。我们不控制这些第三方网站，也不对其隐私声明负责。当您离开我们的网站时，我们鼓励您阅读您访问的每个网站的隐私政策。',
      sec10Title: '10. 隐私政策的变更',
      sec10P1: '我们可能会不时更新本隐私政策。当我们进行重大变更时，我们将在网站上发布更新后的政策，并更新顶部的"最后更新日期"。我们鼓励您定期查看本隐私政策以了解我们如何保护您的信息。',
      sec11Title: '11. 联系我们',
      sec11P1: '如果您对本隐私政策有任何疑问、意见或请求，请联系我们：',
      sec11P2: '我们将在合理的时间内回复您的询问。',
      footerText: '感谢您阅读我们的隐私政策。我们致力于保护您的隐私权，并确保您的个人信息得到适当的处理和保护。'
    },
    terms: {
      introP1: '欢迎访问我们的网站。本使用条款构成您与XX科技有限公司之间具有法律约束力的协议，规定了您访问和使用我们网站和服务的条款和条件。',
      introP2: '通过访问或使用我们的网站，您确认您已阅读、理解并同意受本使用条款的约束。如果您不同意这些条款，请不要使用我们的网站或服务。',
      sec1Title: '1. 定义',
      sec1Intro: '在本使用条款中：',
      sec1Item1: '"网站"指由XX科技有限公司运营的网站，包括所有相关页面和服务。',
      sec1Item2: '"服务"指网站提供的任何服务、功能或内容。',
      sec1Item3: '"用户"、"您"或"您的"指访问或使用网站的任何人。',
      sec1Item4: '"我们"、"我们的"或"公司"指XX科技有限公司及其关联公司。',
      sec1Item5: '"内容"指网站上显示或提供的所有信息、文本、图片、视频、音频、数据或其他材料。',
      sec2Title: '2. 网站使用',
      sec21Title: '2.1 使用授权',
      sec21P1: '我们授予您有限的、非排他性的、不可转让的权利，允许您出于个人、非商业目的访问和使用我们的网站及其内容。',
      sec22Title: '2.2 使用限制',
      sec22P1: '您同意不会：',
      sec22Item1: '以任何方式干扰或破坏网站的功能',
      sec22Item2: '规避、禁用或以其他方式干扰网站的安全相关功能',
      sec22Item3: '使用自动系统或软件收集或提取网站上的数据',
      sec22Item4: '删除、掩盖或更改网站上的任何版权、商标或其他专有权利通知',
      sec22Item5: '将网站用于任何非法或未经授权的目的',
      sec22Item6: '传播病毒、蠕虫、特洛伊木马或其他具有破坏性的代码',
      sec22Item7: '尝试未经授权访问网站的任何部分、其他账户或连接到网站的任何计算机系统',
      sec3Title: '3. 账户管理',
      sec31Title: '3.1 账户注册',
      sec31P1: '某些网站功能可能需要您创建账户。您同意提供准确、完整和最新的信息，并对保持信息的准确性和更新负责。',
      sec32Title: '3.2 账户安全',
      sec32P1: '您负责维护您的账户安全，包括保护您的密码和限制对您计算机的访问。您同意对您账户下发生的所有活动负责。',
      sec33Title: '3.3 账户终止',
      sec33P1: '我们保留在任何时候因任何理由终止或暂停您的账户访问权限的权利，包括但不限于违反这些使用条款。',
      sec4Title: '4. 知识产权',
      sec41Title: '4.1 我们的知识产权',
      sec41P1: '网站及其原始内容、功能和设计是我们和/或我们的许可方的财产，受著作权、商标、专利、商业秘密和其他知识产权或专有权利法律的保护。',
      sec42Title: '4.2 商标',
      sec42P1: '我们的名称、标志和网站上使用的所有相关名称、设计标记和口号是我们或我们附属公司的商标。未经我们事先书面许可，您不得使用这些商标。',
      sec43Title: '4.3 用户生成内容',
      sec43P1: '如果您向网站提交、上传或发布任何内容，您授予我们在全球范围内免版税、永久、不可撤销的权利，允许我们使用、复制、修改、改编、分发、传输、公开展示和创建该内容的衍生作品。',
      sec5Title: '5. 第三方链接和内容',
      sec5P1: '我们的网站可能包含指向第三方网站或服务的链接，这些网站或服务不由我们拥有或控制。',
      sec5P2: '我们对任何第三方网站的内容、隐私政策或做法不承担任何责任。您进一步确认并同意，我们不应对您因使用或依赖任何第三方网站或服务的可用内容而直接或间接遭受的任何损害或损失负责或承担责任。',
      sec5P3: '我们强烈建议您阅读您访问的每个网站的条款和条件以及隐私政策。',
      sec6Title: '6. 免责声明',
      sec6P1: '我们的网站和服务按"原样"和"可用"的基础提供，没有任何形式的明示或暗示的保证。',
      sec6P2: '在法律允许的最大范围内，我们不作任何明示或暗示的保证，包括但不限于对适销性、特定用途适用性和非侵权的暗示保证。',
      sec6P3: '我们不保证网站将始终可用、安全或无错误，也不保证网站将满足您的需求或期望。',
      sec7Title: '7. 责任限制',
      sec7P1: '在法律允许的最大范围内，无论在任何情况下，我们对任何直接的、间接的、附带的、特殊的、惩罚性的或后果性的损害赔偿（包括但不限于业务利润损失、业务中断、商业信息丢失或任何其他金钱损失）均不承担责任，即使我们已被告知此类损害的可能性。',
      sec8Title: '8. 赔偿',
      sec8P1: '您同意赔偿、保护并使我们及我们的母公司、子公司、关联公司、合作伙伴、高管、董事、代理人、员工、承包商和许可方免受因以下原因导致的或与之相关的任何索赔、损失、责任、费用和支出（包括合理的律师费）的损害：',
      sec8Item1: '您违反这些使用条款的任何规定',
      sec8Item2: '您违反任何第三方权利，包括但不限于任何版权、财产或隐私权',
      sec8Item3: '您对我们网站的使用',
      sec9Title: '9. 适用法律',
      sec9P1: '这些使用条款应受中华人民共和国法律管辖并按其解释，不考虑任何法律冲突原则。',
      sec9P2: '您同意接受中华人民共和国法院的专属管辖权，解决与这些条款相关的任何争议。',
      sec10Title: '10. 条款变更',
      sec10P1: '我们可能随时修改这些使用条款。更新后的条款将在我们的网站上发布，并在发布时立即生效。',
      sec10P2: '在我们做出任何更改后继续使用网站，即表示您接受修改后的条款。我们建议您定期查看这些条款。',
      sec11Title: '11. 通用条款',
      sec111Title: '11.1 完整协议',
      sec111P1: '这些使用条款构成您与我们之间关于我们网站使用的完整协议，取代任何先前的协议。',
      sec112Title: '11.2 弃权和可分割性',
      sec112P1: '我们未能执行这些使用条款的任何权利或规定不构成对该权利或规定的放弃。如果这些使用条款的任何规定被认定为无效或不可执行，剩余规定仍将完全有效。',
      sec113Title: '11.3 转让',
      sec113P1: '未经我们事先书面同意，您不得转让这些使用条款下的权利或义务。我们可以自由地转让这些使用条款。',
      sec12Title: '12. 联系我们',
      sec12P1: '如果您对这些使用条款有任何疑问，请联系我们：',
      footerText: '感谢您阅读我们的使用条款。通过继续使用我们的网站和服务，您表示同意受这些条款的约束。'
    }
  },
  search: {
    pageTitle: '搜索结果',
    placeholder: '输入关键词搜索',
    typeAll: '全部',
    typeNews: '新闻',
    typeProduct: '产品',
    typeDocs: '文档',
    typeAbout: '关于我们',
    typeRecruits: '招聘',
    typeOther: '其他',
    stats: '共找到 {count} 条结果，耗时 {time}秒',
    emptyDesc: '没有找到匹配的结果',
    emptyWithQuery: '没有找到与“{q}”匹配的结果',
    clearBtn: '清空搜索条件',
    result1Title: '公司简介',
    result1Desc: '我们是一家专注于<span class="highlight">企业</span>服务的科技公司，致力于提供最优质的解决方案...',
    result2Title: '最新企业动态：公司获得A轮融资',
    result2Desc: '近日，我司完成A轮融资，投资方为知名风投机构...',
    result3Title: '2023年度企业招聘计划',
    result3Desc: '2023年，公司将在全国范围内招聘优秀人才，岗位包括...',
    result4Title: '产品介绍：企业级SaaS解决方案',
    result4Desc: '我们的<span class="highlight">企业</span>级SaaS解决方案，专为中大型企业设计...',
    result5Title: '企业文化与价值观',
    result5Desc: '公司秉承“诚信、创新、协作、卓越”的核心价值观...',
    result6Title: '技术文档：API集成指南',
    result6Desc: '本文档详细介绍了如何将我们的API集成到您的<span class="highlight">企业</span>系统中...'
  },
  sitemap: {
    secHome: '首页',
    linkHome: '首页',
    secAbout: '关于我们',
    linkProfile: '公司简介',
    linkHistory: '企业历史',
    linkTeam: '团队介绍',
    linkOrganization: '组织架构',
    linkHonors: '荣誉资质',
    secNews: '新闻资讯',
    linkNews: '新闻中心',
    linkMedia: '媒体报道',
    linkVideo: '视频中心',
    secProduct: '产品中心',
    linkProduct: '产品介绍',
    linkInnovation: '创新发展',
    linkSocialResp: '社会责任',
    secServices: '服务支持',
    linkBoxs: '业务领域',
    linkServices: '服务范围',
    linkProjects: '项目案例',
    secDocs: '文档中心',
    linkDocs: '文档列表',
    secRecruits: '招聘信息',
    linkRecruits: '招聘概览',
    linkCampus: '校园招聘',
    linkSocial: '社会招聘',
    linkIntern: '实习生招聘',
    secTouch: '联系我们',
    linkTouch: '联系方式',
    secOther: '其他',
    linkSearch: '搜索',
    linkPrivacy: '隐私政策',
    linkTerms: '使用条款'
  }
}
